import React, { useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { RiArrowGoBackLine } from "react-icons/ri";
import {
  Button,
  ButtonGroup,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from "reactstrap";
import Select from "react-select";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { isUrdu } from "../../../constants/const";
import { DOCUMENT_STYLES } from "../hooks/useDocumentUtils";
/**
 * DocumentHeader Component
 * Handles search, filtering, and view options
 */
const DocumentHeader = ({
  searchTerm,
  selectedTags,
  handleSearchTagsChange,
  documentTagsList,
  onDocumentTagsMenuOpen,
  handleSearch,
  handleClearSearch,
  setSearchTerm,
  deletionInProgress,
  uploadInProgress,
  searchBoxRef,
  customOption,
  customMultiValue,
}) => {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  useEffect(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);
  const submitSearch = () => {
    handleSearch(localSearchTerm);
  };
  const clearSearch = () => {
    setLocalSearchTerm("");
    setSearchTerm("");
    handleClearSearch();
  };
  const handleSearchInputKeyDown = (event) => {
    if (event.key === "Enter") {
      submitSearch();
    } else if (event.key === "Escape") {
      clearSearch();
    }
  };
  return (
    <div className="ibox-title">
      <Row>
        <Col md="3">
          <h5 style={{ paddingTop: 10 }}>
            <GetLanguageString props={"sidebar_documents"} />
          </h5>
        </Col>
        <Col md="4">
          <div ref={searchBoxRef} style={{ position: "relative", width: "100%" }}>
            <InputGroup>
              <InputGroupText
                className="position-absolute bg-transparent border-0 text-muted"
                style={{
                  zIndex: 4,
                  left: GetSelectedLanguage() === "ur" ? "unset" : "5px",
                  right: GetSelectedLanguage() === "ur" ? "5px" : "unset",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <BsSearch size={17} />
              </InputGroupText>
              <Input
                type="search"
                placeholder={
                  GetSelectedLanguage() === "ur"
                    ? "ڈھونڈیں"
                    : "Search Documents/Folders"
                }
                className={isUrdu(localSearchTerm) ? "ur" : ""}
                value={localSearchTerm}
                onChange={(e) => {
                  setLocalSearchTerm(e.target.value);
                }}
                onKeyDown={handleSearchInputKeyDown}
                style={{
                  textAlign: GetSelectedLanguage() === "ur" ? "right" : "left",
                  direction: GetSelectedLanguage() === "ur" ? "rtl" : "ltr",
                  height: "37px",
                  borderRadius: "20px",
                  padding:
                    GetSelectedLanguage() === "ur"
                      ? "12px 45px 12px 16px"
                      : "12px 16px 12px 45px",
                }}
              />
            </InputGroup>
          </div>
        </Col>
        <Col md="3">
          <Select
            styles={DOCUMENT_STYLES.customSelectStyles}
            options={documentTagsList}
            components={{
              Option: customOption,
              MultiValue: customMultiValue,
            }}
            value={selectedTags}
            isMulti
            onMenuOpen={onDocumentTagsMenuOpen}
            onKeyDown={handleSearchInputKeyDown}
            onChange={handleSearchTagsChange}
            className={
              GetSelectedLanguage() === "ur"
                ? "basic-multi-select ur no-drag"
                : "basic-multi-select no-drag"
            }
            placeholder={GetSelectedLanguage() === "ur" ? "ٹیگز" : "Tags"}
            classNamePrefix="select"
          />
        </Col>
        <Col md="2">
          <ButtonGroup className={GetCustomStyles().btn_group_style}>
            <Button
              disabled={deletionInProgress || uploadInProgress}
              color="default"
              size="sm"
              onClick={submitSearch}
            >
              <BsSearch size={14} style={{ marginBottom: 2 }} />
              &nbsp;
              <GetLanguageString props={"common_search"} />
            </Button>
            &nbsp;&nbsp;
            <Button
              color="default"
              size="sm"
              disabled={
                (localSearchTerm === "" && selectedTags.length === 0) ||
                deletionInProgress ||
                uploadInProgress
              }
              onClick={clearSearch}
            >
              <RiArrowGoBackLine size={14} style={{ marginBottom: 2 }} />
              &nbsp;
              <GetLanguageString props={"courses_participants_back"} />
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </div>
  );
};
export default DocumentHeader;
